import { css } from 'lit';
import { tagName } from '../../helpers/element.helper';

export const tag = tagName('tree');

export const styles = [
  css`
    :host {
      display: block;
      font-size: 0;
    }
  `,
];
